export const smallPadding = 30
export const lineSpan = 70
export const textPadding = 8